<div id="todo-planner" class="k-h-full k-d-flex k-flex-column">
  <section id="todo-planner-control-bar-wrapper">
    <app-planner-control-bar
      [startOfMonth]="todoPlannerService.todoPlannerModel.plannerStart"
      [prev]="todoPlannerControlBarService.prev.bind(todoPlannerControlBarService)"
      [today]="todoPlannerControlBarService.today.bind(todoPlannerControlBarService)"
      [next]="todoPlannerControlBarService.next.bind(todoPlannerControlBarService)"
    >
      <div class="title-content k-d-inline-flex k-align-items-center k-flex-1" title-content>
        <div class="k-d-inline-flex k-align-items-baseline">
          <h3 class="headline k-m-0 k-font-weight-semibold">Aufgabenplaner</h3>
          <h5 class="headline k-ml-2.5 k-mt-1px k-mb-0">
            (<a href="#"><span class="k-font-weight-semibold">8</span> offen</a>)
          </h5>
        </div>
        <div class="k-ml-auto k-mr-15">
          <span
            class="icon-button"
            #anchor
            (click)="togglePopup()"
            appClickOutside
            [elementVisible]="!!this.showPopup()"
            (clickOutside)="togglePopup()"
          >
            <fa-icon class="icon turquoise k-mr-1.5" size="sm" [icon]="faFilter"></fa-icon>
            <span>Filter</span>
          </span>
          @if (showPopup()) {
            <kendo-popup [anchor]="anchor">
              <div class="content k-p-3">
                <div>
                  <input type="checkbox" kendoCheckBox />
                  <kendo-label class="k-checkbox-label k-mr-2" text="Erledigte Aufgaben anzeigen">
                  </kendo-label>
                </div>

                <div>
                  <input type="checkbox" kendoCheckBox />
                  <kendo-label class="k-checkbox-label k-mr-2" text="Nur meine Aufgaben anzeigen">
                  </kendo-label>
                </div>
                <div>
                  <input type="checkbox" kendoCheckBox />
                  <kendo-label class="k-checkbox-label" text="Alle Teamaufgaben anzeigen">
                  </kendo-label>
                </div>
              </div>
            </kendo-popup>
          }
        </div>
      </div>
    </app-planner-control-bar>
  </section>

  <section id="todo-planner-body" class="k-flex-1">
    @if (plannerViewMode() === TodoPlannerViews.WeekView) {
      <app-todo-planner-week-view />
    }
  </section>
</div>
